import React, { useEffect, useState } from 'react'
import { Button, Grid, Paper, TextField } from '@material-ui/core';
import { globalGetService } from '../../../utils/globalApiServices';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import { Autocomplete } from '@material-ui/lab';
import { Skeleton } from '@material-ui/lab';
import { PageLoader, EmptyCollection } from "../../../shared_elements";
import { smbcInstance } from '../../../shared_elements/components';

function FleetSb() {
    const [skeltonLoader, setSkeltonLoader] = useState(false);
    const [pageLoader, setPageLoader] = useState(false);
    const [fleetSb, setFleetSb] = useState({});
    const [yearsData, setYearsData] = useState({});
    const [selectedYear, setSelectedYear] = useState({});

    useEffect(() => {
        fleetSbListing({ per_page: 250, year_view: true });
    }, []);

    const fleetSbListing = (query, loader) => {
        loader === "pageLoader" ? setPageLoader(true) : setSkeltonLoader(true);
        globalGetService(smbcInstance ? `/camo/smbc_dashboard/sb_due/` : `/camo/dashboard/sb_due/`, { ...query })
            .then((response) => {
                setFleetSb(response.data);
                const minYear = response.data.year?.min_year;
                const maxYear = response.data.year?.max_year;
                const yearMenu = [];
                for (let i = minYear; i <= maxYear; i++) {
                    yearMenu.push({ label: i.toString(), value: i.toString() });
                }
                setYearsData(yearMenu);
                setSelectedYear(response.data.year?.year);
                loader === "pageLoader" ? setPageLoader(false) : setSkeltonLoader(false);
            })
            .catch((error) => {
                console.error('Error in fetching data:', error);
                setPageLoader(false);
                setSkeltonLoader(false);
            });
    };

    const renderYearData = (yearData) => {
        if (Array.isArray(yearData) && yearData.length > 0) {
            return yearData.map((item, index) => (
                <a
                    key={index}
                    href={`/${item.asset_id}/${item?.asset_type}/sb/list?record_id=${item?.record_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <p className="cal-table-row">
                        {item?.engine_type + ", ESN: " + item?.esn + " "}@
                        <b>{item?.due_date ? " " + moment(item?.due_date).format('MMM-YYYY') : null}</b>
                    </p>
                </a>
            ));
        }
        return <span>No data available</span>;
    };

    return (
        <>
            {skeltonLoader ? (
                <Skeleton variant="rect" animation="wave" height={400} />
            ) : (
                <Paper className="dashboard-chart" square>
                    <Grid container spacing={0} className="dashboard-chart-title">
                        <Grid item xs={12} sm={5}>
                            <h5>Fleet SB Due</h5>
                        </Grid>
                        <Grid item xs={12} sm={7}>
                            <ul className="list-inline fleet-header-actions">
                                {selectedYear === "monthly_year" && (
                                    <li className="list-inline-item">
                                        <Autocomplete
                                            options={yearsData}
                                            getOptionLabel={option => option.label}
                                            disableClearable
                                            className="fleet-due fleet-year-autocomplete"
                                            onChange={(e, value) => fleetSbListing({ per_page: 250, year_view: value?.value }, 'pageLoader')}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    className="fleet-year-field"
                                                    label="Year"
                                                    placeholder="Select Year"
                                                    margin="normal"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </li>
                                )}
                                <li className="list-inline-item">
                                    <Button variant="outlined" color="primary" onClick={() => fleetSbListing({ per_page: 250, year_view: new Date().getFullYear() }, 'pageLoader')}>
                                        Monthly
                                    </Button>
                                </li>
                                <li className="list-inline-item">
                                    <Button variant="outlined" color="primary" onClick={() => fleetSbListing({ per_page: 250, year_view: true }, 'pageLoader')}>
                                        Yearly
                                    </Button>
                                </li>
                            </ul>
                        </Grid>
                    </Grid>
                    <Grid container spacing={0}>
                        <Grid item xs={12} className="fleet-data-container">
                            {fleetSb?.data ? Object.keys(fleetSb?.data)?.map(year => (
                                <Paper elevation={8} square key={year} className="fleet-year-card">
                                    <h3><b>{year}</b></h3>
                                    {renderYearData(fleetSb?.data[year] || [])}
                                </Paper>
                            )) : <EmptyCollection />}
                        </Grid>
                    </Grid>
                </Paper>
            )}
            {pageLoader && <PageLoader />}
        </>
    );
}

export default withRouter(FleetSb);
